import { Case } from '../models/common-types';
import _ from 'lodash';

export const findCaseFromRoot = (root: Case[], caseId: string) => {
    let foundCase;
    const currentChildrenCase = _.find(root, { id: caseId });
    if (currentChildrenCase) {
        foundCase = currentChildrenCase;
    } else {
        root?.forEach((currentCase: Case) => {
            const childCaseFound = findCaseFromRoot(currentCase.children, caseId);
            if (childCaseFound) {
                foundCase = childCaseFound;
            }
        });
    }

    return foundCase || null;
};

export const getIndexesOf = (search: string | string[], str: string | String, caseSensitive?: boolean) => {
    const indexes = [];

    if (!str) return indexes;
    const strText = str.toString();

    if (typeof search === 'string') {
        const term = search;
        const termLen = term?.length;
        if (!termLen) return indexes;

        let startIndex = 0,
            index;
        let searchTarget = strText;
        let searchTerm = term;

        if (!caseSensitive) {
            searchTarget = searchTarget.toLowerCase();
            searchTerm = searchTerm.toLowerCase();
        }

        while ((index = searchTarget.indexOf(searchTerm, startIndex)) > -1) {
            indexes.push(index);
            startIndex = index + termLen;
        }
    } else {
        const potentialMatches = [];

        const sortedTerms = (search as string[]).filter((term) => term?.length).sort((a, b) => b.length - a.length);

        sortedTerms.forEach((term) => {
            let currentIndex = 0;
            const searchTarget = caseSensitive ? strText : strText.toLowerCase();
            const searchTerm = caseSensitive ? term : term.toLowerCase();

            while (currentIndex < searchTarget.length) {
                const index = searchTarget.indexOf(searchTerm, currentIndex);
                if (index === -1) break;

                const beforeChar = index > 0 ? searchTarget.charAt(index - 1) : '';
                const afterChar =
                    index + searchTerm.length < searchTarget.length
                        ? searchTarget.charAt(index + searchTerm.length)
                        : '';

                const isWordStart = index === 0 || /[\s.,;:!?()[\]{}"'\-_=+<>/\\|~`@#$%^&*]/g.test(beforeChar);
                const isWordEnd =
                    index + searchTerm.length === searchTarget.length ||
                    /[\s.,;:!?()[\]{}"'\-_=+<>/\\|~`@#$%^&*]/g.test(afterChar);

                if (isWordStart && isWordEnd) {
                    potentialMatches.push({
                        start: index,
                        end: index + searchTerm.length,
                        term: term,
                    });
                }

                currentIndex = index + 1;
            }
        });

        potentialMatches.sort((a, b) => {
            if (a.start !== b.start) return a.start - b.start;
            return b.end - b.start - (a.end - a.start);
        });

        const finalMatches = [];
        const coveredRanges = [];

        potentialMatches.forEach((match) => {
            const hasOverlap = coveredRanges.some((range) => {
                if (range.start <= match.start && range.end >= match.end) return true;

                if (Math.max(range.start, match.start) < Math.min(range.end, match.end)) {
                    const overlapSize = Math.min(range.end, match.end) - Math.max(range.start, match.start);
                    if (overlapSize > Math.min(range.end - range.start, match.end - match.start) * 0.25) {
                        return true;
                    }
                }
                return false;
            });

            if (!hasOverlap) {
                finalMatches.push(match);
                coveredRanges.push({ start: match.start, end: match.end });
            }
        });

        finalMatches
            .sort((a, b) => a.start - b.start)
            .forEach((match) => {
                indexes.push(match.start);
            });
    }

    return indexes.sort((a, b) => a - b);
};
